import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import {TopElevenTeam} from 'app/components/topEleven/TopElevenTeam';
import {PenaltyBox} from 'app/components/topEleven/PenaltyBox';
import {array, bool} from 'prop-types';

const TopElevenContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.white};
  width: 100%;
  padding: 0 ${SIZES['16']};
  @media only screen and (max-width: 600px) {
    padding: 0 ${SIZES['8']};
  }
`;

const Field = styled.div`
  position: relative;
  width: 100%;
  min-height: 37.625rem;
  background-color: ${COLORS.darkGreen};
`;

const FieldLine = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: inherit;
  min-height: 39.25rem;
  border: ${SIZES['4']} solid rgba(255, 255, 255, 0.2);
  -webkit-background-clip: padding-box; /* for Safari */
  background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */
`;

const MidLine = styled.div`
  height: ${SIZES['4']};
  width: 100%;
  position: absolute;
  top: 19.5rem;
  opacity: 0.2;
  background-image: url('https://www.fupa.net/midline.svg');
  background-repeat: repeat;
  border-left: ${SIZES['4']} solid transparent;
  border-right: ${SIZES['4']} solid transparent;
  -moz-background-clip: padding; /* Firefox 3.6 */
  -webkit-background-clip: padding; /* Safari 4? Chrome 6? */
  background-clip: padding-box; /* Firefox 4, Safari 5, Opera 10, IE 9 */
`;

const Placeholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const TopEleven = ({isFetching, topEleven}) => {
  const content = isFetching ? (
    <Placeholder>
      <Typography variant='body1'>Elf des Jahres wird geladen ...</Typography>
    </Placeholder>
  ) : topEleven.length ? (
    <TopElevenTeam topeleven={topEleven} />
  ) : (
    <Placeholder>
      <Typography variant='body1'>Fehler beim Laden der Elf des Jahres.</Typography>
    </Placeholder>
  );

  return (
    <TopElevenContainer>
      <Field>
        <FieldLine>
          <PenaltyBox position='top' />
          <MidLine />
          <PenaltyBox position='bottom' />
          {content}
        </FieldLine>
      </Field>
    </TopElevenContainer>
  );
};

TopEleven.propTypes = {
  topEleven: array,
  isFetching: bool,
};

export {TopEleven};
